<meta name="viewport" content="width=device-width, initial-scale=1.0">
</meta>
<template>
  <div class="NewNews"  :key="$route.params.id">
    <div class="firstNews">
      <div v-for="element in getByNews(selected.id)" :key="element.id">
        <div class="cardFirstNews" rounded="0">
          <div class="imgCol1">
            <img class="styleImg" :src="element.images[0] ? '/repo/wot-lab/img/' + element.images[0] : '/repo/wot-lab/img/no_image.jpg'" :alt="element">
          </div>
          <div class="iconsPortada">
            <div>
              <v-icon>mdi-calendar-month-outline</v-icon>
              <div class="stylrDateContainer">
                <span class="stylrDate">{{ formatExtendedDate(element.fecha, element?.hora) }}</span>
              </div>
            </div>
            <div>
              <v-icon>mdi-text-box-edit-outline</v-icon>
              <div class="stylrDateContainer">
                <span class="stylrDate">{{ element.author }}</span>
              </div>
            </div>
          </div>
          <div class="title-card-1">
            {{ element.title }}
          </div>
          <div class="textCardCol1">
            <p class="textWithImage">
              <figure v-if="element.images[1]" class="imageFigureRight">
                <img class="imageTex" alt="Descripción de la imagen" :src="'/repo/wot-lab/img/' + element.images[1]">
                <figcaption v-if="element.image_caption[0]" class="imageCaption">{{element.image_caption[0]}}</figcaption>
              </figure>
              {{ element.description }}
              <figure v-if="element.images[2]" class="imageFigureLeft">
                <img class="imageTex2" :src="'/repo/wot-lab/img/' + element.images[2]">
                <figcaption v-if="element.image_caption[1]" class="imageCaption">{{element.image_caption[1]}}</figcaption>
              </figure>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="moreNews">
      <div class="moreTitle">MORE NEWS</div>
      <div v-for="item in lastThreeNews" :key="item.id">
        <div class="cardsMoreNews" rounded="0">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-img class="white--text align-end position-relative imageCol2" v-on:click="redirect(item.id)" :src="item.images[0] ? '/repo/wot-lab/img/' + item.images[0] : '/repo/wot-lab/img/no_image.jpg'">
                <v-overlay absolute :value="hover" color="rgba(30, 139, 195, 0.7)">
                  <img src="@/assets/click.png" alt="Click Icon" v-if="hover" class="hoverNews" />
                </v-overlay>
                </v-img>
              </template>
            </v-hover>
          <div class="icons">
            <div>
              <v-icon class="sizeIcon">mdi-calendar-month-outline</v-icon>
              <div class="stylrDateContainerMore">
                <span class="stylrDate">{{ formatReducedDate(item.fecha, item?.hora) }}</span>
              </div>
            </div>
            <div>
              <v-icon class="sizeIcon">mdi-text-box-edit-outline</v-icon>
              <div class="stylrDateContainerMore">
                <span class="stylrDate">{{ item.author }}</span>
              </div>
            </div>
          </div>
          <div class="titles-cardsCol2">
            <button class="buton" v-on:click="redirect(item._id)">
              {{ item.title }}
            </button>
          </div>
          <div class="text-cardsCol2">
            {{ item.announce }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
//import newsAPI from "../../services/newsAPI";
import newsData from "@/assets/json/news.json";

export default {
  name: "NewsDetails",
  data() {
    return {
      //myData: this.fetchNews(),
      mainNews: newsData,
      selected: {}

    };
  },
  watch: {
    '$route.params.id': function(newId) {
      // Actualizar la noticia seleccionada
      this.selected = this.mainNews.find(news => news.id == newId) || {}; // Encontramos la noticia que corresponde al id de la ruta

      // Si es necesario, también puedes actualizar las tres últimas noticias aquí
    }
  },
  methods: {
    getByNews(id) {
      return this.mainNews.filter(news => news.id == id)
    },
    /** 
    fetchNews() { // renamed from getNews to fetchNews
      newsAPI.get("/posts").then((response) => {
        this.mainNews = response.data; // directly assign the fetched data to mainNews
      });
    },
    */
    redirect(id) {
      this.$router.push({ name: 'news-details', params: { id: id } });
    },
    parseDate(dateInput, timeInput = "00:00") {
    if (!dateInput || typeof dateInput !== 'string') return null;

    const dateRegex = /^(?:(\d{2})\/(\d{2})\/(\d{2,4})|(\d{2})-(\d{2})-(\d{2,4}))$/;
    const match = dateInput.match(dateRegex);
    if (!match) return null;

    let day, month, year;

    if (match[1] && match[2] && match[3]) {
      // dd/mm/yy o dd/mm/yyyy
      day = match[1];
      month = match[2];
      year = match[3];
    } else if (match[4] && match[5] && match[6]) {
      // mm/dd/yy o mm/dd/yyyy
      month = match[4];
      day = match[5];
      year = match[6];
    } else {
      return null;
    }

    // Convertir años de 2 dígitos a 4 dígitos (suponiendo 2000-2099)
    if (year.length === 2) {
      year = year < 50 ? `20${year}` : `19${year}`;
    }

    // Crear la fecha en formato ISO (yyyy-mm-dd)
    const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    // Crear la fecha completa con la hora, si se proporciona
    const fullDate = `${isoDate}T${timeInput}:00`;

    // Retornar la fecha completa como un objeto Date
    return new Date(fullDate);
  },

  /**
   * Función para formatear la fecha de manera simplificada
   * Muestra solo fecha (día, mes, año)
   */
  formatReducedDate(dateString, timeString = "00:00") {
    const date = this.parseDate(dateString, timeString);
    if (!date || isNaN(date)) return "Invalid date"; // Manejar fechas no válidas
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/Paris' };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  },

  /**
   * Función para formatear la fecha de manera extendida
   * Muestra fecha (día, mes, año) y hora (hora, minutos)
   */
  formatExtendedDate(dateString, timeString = "00:00") {
    const date = this.parseDate(dateString, timeString);
    if (!date || isNaN(date)) return "Invalid date"; // Manejar fechas no válidas
    const options = { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      timeZone: 'Europe/Paris' 
    };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }
  },
  computed: {
    //lastThreeNews shows the last 3 news
    lastThreeNews() {
      const selectedId = String(this.selected.id); // Convertir a cadena
      return this.mainNews
        .filter(item => String(item.id) !== selectedId) // Asegurar comparación correcta
        .sort((a, b) => {
          const dateA = this.parseDate(a.fecha, a.hora || "00:00");
          const dateB = this.parseDate(b.fecha, b.hora || "00:00");
          return dateB - dateA;
        })
        .slice(0, 3);
    },

  },
  mounted() {
    /**
    this.fetchNews();
     */
  },
  created() {
    this.selected = this.$route.params;
  }

};
</script>

<style>
@media screen and (min-width: 1100px) {
  .NewNews {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /*grid-gap: 10px;*/
    grid-auto-rows: minmax(100px, auto);
    padding: 1rem 3rem;
    position: relative;
    margin: auto;
    max-width: 1150px;
  }

  .firstNews {
    display: grid;
    grid-column-start: 1;
    grid-column-end: 4;
    margin-right: 1rem;
    position: relative;
  }

  .textCardCol1 {
    padding: 0 !important;
    font-weight: bolder;
  }

  .moreNews {
    /*place-items: center;*/
    display: grid;
    position: relative;
    grid-column-start: 4;
    grid-column-end: 5;
    align-content: start;
  }

  .moreTitle {
    display: grid;
    background-color: #2E3038;
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    height: 40px;
    margin-bottom: 1rem;
  }

  .v-card__title {
    font-weight: bold;
  }

  .title-card-1 {
    padding: 0;
    margin-top: 0.5rem;
    font-weight: bold;
    color: #2D2D2A !important;
    font-size: 1.4rem;
    line-height: 1.1;
  }

  .imgCol1 {
    display: grid;
    position: relative;
    width: 100%;
    padding-top: 42.25%;
    /* 16:9 Aspect Ratio */
  }

  .styleImg {
    display: grid;
    position: absolute;
    width: 100%;
    /* Para que la imagen ocupe todo el ancho disponible */
    height: 100%;
    /* Para que la imagen ocupe todo el alto disponible */
    object-fit: cover;
  }

  .imageTex {
    float: right;
    margin: 1rem;
    height: 10rem;
    width: 20rem;
  }

  .imageTex2 {
    float: left;
    margin: 1rem;
    height: 10rem;
    width: 20rem;
  }

  .imageFigureRight {
    float: right;
  }

  .imageFigureLeft {
    float: left;
  }

  .imageCaption {
    font-size: 0.8rem;
    color: #666;
    line-height: 0.8;
    text-align: center;
    font-style: italic;
  }

  /*.v-card__text{
  padding:16px;
  margin-top: 0.5rem;
  color: #2D2D2A !important;
  }
*/

  .imageCol2 {
    max-height: 150px;
    width: 100%;
    object-fit: cover;
  }

  .cardFirstNews {
    display: grid;
    position: relative;
    color: #2D2D2A;
  }

  .cardsMoreNews {
    /* box-shadow: none !important;*/
    display: grid;
    align-items: start;
    font-size: 1.4rem;
    letter-spacing: 0.0125em;
    word-break: break-word;
    color: #2D2D2A;
    position: relative;
    margin-bottom: 1rem;
  }


  .theme--light.v-icon {
    color: #FFFFFF;

  }

  .sizeIcon {
    font-size: smaller !important;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }

  .iconsPortada {
    color: #FFFFFF;
    position: relative;
    size: 1rem;
    display: flex;
    justify-content: last baseline;
    background-color: #2E3038;
    padding: 0.5rem;
  }

  .icons {
    display: flex;
    justify-content: space-between;
    size: 1rem;
    padding: 0 0.5rem;
    background-color: #2E3038;
  }

  .titles-cardsCol2 {
    padding: 0;
    margin-top: 0.5rem;
    font-weight: bold;
    color: #2D2D2A !important;
    line-height: 1;
  }

  .buton {
    text-align: left !important;
    font-size: 1.1rem;
    line-height: 1.2;
  }

  .text-cardsCol2 {
    padding: 0;
    font-weight: bolder;
    margin-bottom: 1.5rem;
    margin-top: 0.2rem;
    /*color: #2D2D2A !important;*/
    font-size: 14px;

  }

  .stylrDateContainer {
  max-width: 200px; /* Ajusta este valor según sea necesario */
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center; /* Centra el texto horizontalmente */
  vertical-align: middle; /* Alinea verticalmente */
  line-height: 1.5; /* Ajusta la altura de línea para centrar verticalmente */
}

.stylrDateContainerMore {
  max-width: 120px; /* Ajusta este valor según sea necesario */
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center; /* Centra el texto horizontalmente */
  vertical-align: sub; /* Alinea verticalmente */
  line-height: 1.5; /* Ajusta la altura de línea para centrar verticalmente */
}

.stylrDate {
  color: #FFFFFF;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  font-size: 12px;
  font-weight: normal;}
}

@media screen and (max-width: 1100px) {
  .imgCol1 {
    position: relative;
    width: 100%;
  }

  .styleImg {
    width: 100%;
    max-height: 20rem;
    object-fit: cover;
  }

  .moreNews {
    padding: 0 1rem;
  }

  .moreTitle {
    display: grid;
    background-color: #2E3038;
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 1rem;
  }

  .cardsMoreNews {
    box-shadow: none !important;
  }

  .cardFirstNews {
    box-shadow: none !important;
    padding-bottom: 0;
  }


  .imageTex, .imageTex2 {
    width: 95%;
    height: 15rem;
    display: block;
    margin: 1rem auto;
    object-fit: cover;
  }

  .title-card-1 {
    font-weight: bold;
    font-size: 1.3rem;
    line-height: 1.3;
    padding: 0.5rem;
    color: #2D2D2A !important;
  }

  .titles-cardsCol2 {
    font-size: 1rem;
    font-weight: bold;
    color: #2D2D2A;
  }

.textCardCol1 {
  padding: 0 1rem;
  font-weight: bolder;
}

.text-cardsCol2 {
  font-weight: bolder;
  margin-bottom: 1.5rem;
}

.iconsPortada {
  padding: 0.3rem;
  size: 1rem;
  display: flex;
  justify-content: last baseline;
  background-color: #2E3038;
}

.icons {
  size: 1rem;
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  background-color: #2E3038;
}

.imageCol2 {
    max-height: 150px;
    width: 100%;
    object-fit: cover;
  }

  .stylrDateContainer {
  max-width: 300px; /* Ajusta este valor según sea necesario */
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle; /* Alinea verticalmente */
  line-height: 1.5; /* Ajusta la altura de línea para centrar verticalmente */
}

.stylrDateContainerMore {
  max-width: 120px; /* Ajusta este valor según sea necesario */
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle; /* Alinea verticalmente */
  line-height: 1.5; /* Ajusta la altura de línea para centrar verticalmente */
}

.stylrDate {
  color: #FFFFFF;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  font-size: 12px;
  font-weight: normal;
}

.theme--light.v-icon {
  color: #FFFFFF;
}

}

</style>